import mapActions from './mapActions';

export default mapActions('building_top_entities', {
    fetchAll_url: (data) => `/api/buildings/${data.building_id}/top_entities`
});